import { Component, Input } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from './../../services/http/http.service';

@Component({
    selector: 'svg-render-external',
    templateUrl: 'svg-render-external.component.html',
    styleUrls: ['svg-render-external.component.scss'],
})
export class SvgRenderExternalComponent {

    @Input() public svgUrl: string;

    constructor(
        private http: HttpService,
    ) { }

    public ngOnInit() {
        const headers = new HttpHeaders({ 'Access-Control-Allow-Origin': '*' });

        this.http.get(this.svgUrl, headers)
            .subscribe((data) => {
                // console.log(data);
            });
    }
}
